<template>
    <div class="slider">
        <i v-if="list.length>limit" class="el-icon-arrow-left" @click="moveLeft()"></i>
        <i v-if="list.length>limit" class="el-icon-arrow-right" @click="moveRight()"></i>
        <div class="slider-view" :style="{width:calc_width+'px'}">
            <div class="slider-wrap" ref="wrap">
                <div class="slider-item" :style="{'border-color':color}" v-for="item in list" :key="item.id">
                    <div class="head overhide" :style="{'background':color}" :title="item.currency_name">{{ item.currency_name }}</div>
                    <div class="main" :style="{'color':color}">{{ text }}：<span>{{ item[valueKey] || 0 }}</span>币</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        // props:['list','limit','budget','color'],
        props:{
            list:{  //主要列表
                type:Array,
                default:function(){
                    return [];
                },
            },
            limit:{  //超出隐藏限制
                type:Number,
                default:5
            },
            text:{  //文本描述
                type:String,
                default:"奖金"
            },
            valueKey:{  //取值的key
                type:String,
                default:'current_currency_balance',
            },
            color:{  //主题色
                type:String,
            }

        },
        data(){
            return {
                count:1,
            }
        },

        computed:{
            max_count(){
                return Math.ceil(this.list.length/this.limit);
            },
            calc_width(){  //计算出来的视窗宽度
                let box_w = 150;  //css 方块宽
                let align = 30;   //css 对齐值
                if(this.list.length < this.limit){
                    return this.list.length*(box_w+align);
                }else{
                    return this.limit*(box_w+align);
                }
            }
        },

        watch:{
            list(val){
                this.$refs['wrap'].style.transform =  `translateX(0)`;
            },
        },

        methods:{
            moveLeft(){
                console.log('left')
                if(this.count == 1){
                    return;
                }
                let str = this.$refs['wrap'].style.transform;
                this.$refs['wrap'].style.transform = `translateX(${this.getNum(str)+this.calc_width}px)`
                this.count--;
            },
            moveRight(){
                console.log('right')
                if(this.count == this.max_count){
                    this.count = 1;
                    this.$refs['wrap'].style.transform = `translateX(0)`;
                    return;
                }
                let str = this.$refs['wrap'].style.transform;
                this.$refs['wrap'].style.transform = `translateX(${this.getNum(str)-this.calc_width}px)`
                this.count++;
            },
            getNum(str){
                return parseInt(str.replace(/[\(\)]|(px\))/g,'|').split("|")[1]);
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/var.less";
    @box_h:90px;  //方块高
    @time:0.4s;    //滑动时间
    @box_w:150px;  //方块宽
    @align:30px;   //对齐值
    @color:#ccc;

    // 轮播滚动部分
    .slider{
        position: relative;
        display: inline-block;
        padding:0 15px;
        i{  
            position: absolute;
            top:50%;
            transform: translateY(-50%);
            padding: 10px 0;
            cursor: pointer;
            &:nth-of-type(1){
                left:0;
            }
            &:nth-of-type(2){
                right:0;
            }
        }
    }
    .slider-view{
        // height:@box_h;
        // width:(@box_w + @align)*4;
        overflow: hidden;
        .slider-wrap{
            height:100%;
            white-space: nowrap;
            transition:@time;
            font-size:0;
        }

        .slider-item{
            margin: 0 @align/2;
            border-color:@color;
            height:@box_h;
            width:@box_w;

            .head{
                background:@color;
            }
            .main{
                color:@color;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// asset-slider.vue?1db1e713